import ProjectTeamPaymentsModalModule from './payments-modal.module'

export default ProjectTeamPaymentsModalModule
